import React, { useState } from "react";
import { connect } from "react-redux";
import Table from "@mui/material/Table";
import Typography from "@mui/material/Typography";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import PageTitle from "../components/PageTitle";
import AdminEngagementsTableRow from "./admin-engagements-table-row";
import { endEngagement } from "../admin-actions";
import { StoreState } from "../../redux/configure-store";
import ListHeader from "../../common/components/list-header";
import { isEngagementActive } from '../../common/models';

import { Engagement } from "../types";
import { backgrounds, borders } from "../../theme/theme";

function EngagementsTable(props: any) {
  const {
    engagements,
    navigateToAdminEngagementsViewPage,
    endEngagement: _endEngagement
  } = props;
  const [hideEnded, setHideEnded] = useState(true);
  const columnNames = [
    "Client Name",
    "Developer",
    "Currency",
    "Hourly Rate",
    "Tracking Type",
    "Number of Hours per week",
    "Short Description",
    "Description",
    "Last Timesheet Period Submitted",
    "Start Date",
    "End Date",
  ];

  const activeEngagements = (engagements || []).filter(isEngagementActive);
  const numberOfActiveEngagements = activeEngagements.length;
  const timesheetPeriodMap = new Map<number, any>();

  // determining the last timesheet that was submitted for the engagement
  activeEngagements.forEach((e: Engagement) => {
    const timesheet = props.timesheets.find((t: any) => t.engagement.id === e.id && !!t.submittedAt);
    timesheetPeriodMap.set(e.id, timesheet && timesheet.endDate);
  });

  const displayedEngagements = hideEnded
    ? activeEngagements
    : (engagements || []);

  return (
    <div>
      <PageTitle>Engagements</PageTitle>
      <Box sx={{ mb: 3, p: 2, backgroundColor: backgrounds.page, borderRadius: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="body1">
          <strong>Active Engagements:</strong> {numberOfActiveEngagements}
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={hideEnded}
              onChange={(e) => setHideEnded(e.target.checked)}
            />
          }
          label="Hide ended engagements"
        />
      </Box>
      <Box>
        <Paper elevation={0} sx={{ width: "100%", overflowX: "auto", border: `1px solid ${borders.light}`, borderRadius: 2 }}>
          <Table sx={{ minWidth: 700, mb: 5 }}>
            <ListHeader columns={columnNames} />
            <TableBody>
              {displayedEngagements.map((engagement: Engagement) => {
                return (
                  <AdminEngagementsTableRow
                    lastTimesheetSubmittedAt={timesheetPeriodMap.get(
                      engagement.id
                    )}
                    endEngagement={_endEngagement}
                    engagement={engagement}
                    navigateToAdminEngagementsViewPage={
                      navigateToAdminEngagementsViewPage
                    }
                  />
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </div>
  );
}

const mapStateToProps = (storeState: StoreState) => ({
  engagements: storeState.admin.engagements,
  timesheets: storeState.admin.timesheets,
});

export default connect(mapStateToProps, {
  endEngagement,
})(EngagementsTable);
